/**
 * Script Breakdown — productieplanning engine instellingen.
 */
import React from 'react';
import { Box } from '@mui/material';
import { SettingField, KeyValueEditor, SectionHeader, T } from '../adminSettingsCommon';

const Subhead = ({ children }) => (
  <Box sx={{
    fontFamily: T.fontBody, fontSize: '0.62rem', fontWeight: 800,
    textTransform: 'uppercase', letterSpacing: '0.1em',
    color: T.outlineVariant, mt: 4, mb: 1.5,
  }}>{children}</Box>
);

export default function ScriptBreakdownConfig() {
  return (
    <Box>
      <SectionHeader
        title="Script breakdown engine"
        subtitle="OpenAI-model voor breakdowns en de productieplanning rekenregels."
      />

      <Subhead>OpenAI</Subhead>
      <SettingField
        settingKey="openai_model" label="OpenAI model"
        helperText="Model voor breakdown/shotlist generatie (bijv. gpt-5.4, gpt-5.4-mini)"
      />

      <Subhead>Planning engine</Subhead>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, mb: 2 }}>
        <SettingField settingKey="max_day_minutes" label="Max draaidag (minuten)" type="number"
          helperText="Maximale draaidaglengte (600 = 10 uur)" />
        <SettingField settingKey="lunch_duration" label="Lunchduur (minuten)" type="number"
          helperText="Standaard lunchpauze in minuten" />
        <SettingField settingKey="default_crew_call" label="Crew call"
          helperText="Standaard crew call tijd (HH:MM)" />
        <SettingField settingKey="pre_shot_setup_time" label="Pre-shot setup (minuten)" type="number"
          helperText="Setup-tijd voor eerste shot" />
        <SettingField settingKey="location_warning_threshold" label="Locatie-threshold" type="number"
          helperText="Aantal locaties waarboven waarschuwing" />
      </Box>

      <Subhead>Callsheet</Subhead>
      <SettingField settingKey="callsheet_vertrekadres" label="Vertrekadres (reistijd)"
        helperText="Vanaf dit adres rekent het callsheet de reistijd naar elke locatie (blok Waar)" />

      <KeyValueEditor settingKey="base_times"
        label="Base times (minuten per shot type)"
        helperText="Basistijd in minuten per shot type voor productietijd-berekening" />
      <KeyValueEditor settingKey="time_modifiers"
        label="Time modifiers"
        helperText="Tijdmodifiers: new_location, new_setup, dialogue, complex_movement, extra_cast_per_person, first_shot_multiplier, minimum_shot_time" />
    </Box>
  );
}
